import { Button, Card, CardContent, CardHeader, Switch, Typography } from "@mui/material";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toDate } from "helpers/dateHelper";
import { useGetChannelDetails } from "hooks/useGetChannelDetails";
import withRouter from "hoc/withRouter";
import WhatsappConnect, {
  CHANNEL_STATUS,
  CONNECTION_STATUS,
} from "../Whatsapp/WhatsappConnect";
import { useTranslation } from "react-i18next";
import ChannelConnectionsAdminService from "services/admin/channelConnections";
import { toast } from "react-toastify";
import { TelegramConnect } from "../AIAgents/components/TelegramConnect";
import { InstagramConnect } from "../AIAgents/components/InstagramConnect";
import { TestSandboxConnect } from "../AIAgents/components/TestSandboxConnect";
import { useSelector } from "react-redux";
import { getAgents } from "redux/selectors/getAgents";
import PageGuide from "components/PageGuide/PageGuide";
import ChannelResponders from "./ChannelResponders";
import { CHANNEL_GUIDES, CHANNEL_LABELS } from "components/PageGuide/channelGuides";
import { canDeleteChannel, useDeleteChannel } from "./useDeleteChannel";

const ChannelDetails = ({
  router: {
    params: { channelConnectionID },
  },
}: any) => {
  const { data: channelDetails, refetch } = useGetChannelDetails(channelConnectionID);
  const { t } = useTranslation();
  const agents = ((useSelector(getAgents) as any[]) || []) as any[];
  const navigate = useNavigate();
  const deleteChannel = useDeleteChannel();

  if (!channelDetails) return <div>Загрузка...</div>;

  const linkedAgent = agents.find((a: any) => a.id === channelDetails.agentID);

  const buildChannelConnection = () => {
    switch (channelDetails.source) {
      case "WHATSAPP":
        return <WhatsappConnect channelConnection={channelDetails} refetch={refetch} />;
      case "TELEGRAM":
        return <TelegramConnect channelConnection={channelDetails} refetch={refetch} />;
      case "INSTAGRAM":
        return <InstagramConnect channelConnection={channelDetails} refetch={refetch} />;
      case "TEST_SANDBOX":
        return <TestSandboxConnect channelConnection={channelDetails} refetch={refetch} />;
      default:
        return <div>Неизвестный тип канала</div>;
    }
  };

  const handleChangeStatus = async () => {
    try {
      await ChannelConnectionsAdminService.put(channelDetails.id, {
        status:
          channelDetails.status === CHANNEL_STATUS.ACTIVE
            ? CHANNEL_STATUS.INACTIVE
            : CHANNEL_STATUS.ACTIVE,
      });
      toast.success("Статус канала изменен успешно!");
      refetch();
    } catch (error) {
      toast.error("Ошибка при изменении статуса канала!");
      console.error(error);
    }
  };

  return (
    <div>
      <h3 className="mb-8">Детали подключения канала</h3>
      <Card>
        <CardHeader title={"Информация о канале"} />
        <CardContent>
          <Typography variant="body1">ID: {channelDetails.id}</Typography>
          <Typography variant="body1">Тип канала: {CHANNEL_LABELS[channelDetails.source] || channelDetails.source}</Typography>
          <Typography variant="body1">
            Агент:{" "}
            {channelDetails.agentID
              ? linkedAgent?.name || `#${channelDetails.agentID}`
              : "не привязан"}
          </Typography>
          <div>
            Статус:{" "}
            <Switch
              checked={channelDetails.status === CHANNEL_STATUS.ACTIVE}
              onChange={handleChangeStatus}
              color="primary"
            />
          </div>
          <Typography variant="body1">Создано: {toDate(channelDetails.createdAt)}</Typography>
          <Typography variant="body1">Обновлено: {toDate(channelDetails.updatedAt)}</Typography>
          {canDeleteChannel(channelDetails) && (
            <Button
              className="mt-4"
              variant="outlined"
              color="error"
              startIcon={<MdDelete />}
              onClick={async () => {
                if (await deleteChannel(channelDetails)) {
                  navigate("/admin/channels");
                }
              }}
            >
              Удалить канал
            </Button>
          )}
        </CardContent>
      </Card>
      <ChannelResponders channelConnection={channelDetails} refetch={refetch} />
      {CHANNEL_GUIDES[channelDetails.source] && (
        <PageGuide id={`channel-${channelDetails.source}`} title={CHANNEL_GUIDES[channelDetails.source].title} className="mt-4">
          {CHANNEL_GUIDES[channelDetails.source].body}
        </PageGuide>
      )}
      <Card className="mt-4">
        <CardHeader title="Информация о подключении" />
        <CardContent>
          <div className="mb-2">
            <div>
              Статус подключения: &nbsp;
              <span
                className="font-bold"
                style={{
                  color:
                    channelDetails.connectionStatus === CONNECTION_STATUS.CONNECTED
                      ? "green"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.WAITING_QR
                      ? "orange"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.PENDING
                      ? "orange"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.DISCONNECTED
                      ? "gray"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.ERROR
                      ? "red"
                      : "gray",
                }}
              >
                {t(`CONNECTION_STATUS.${channelDetails.connectionStatus}`)}
              </span>
            </div>
          </div>
          <div>{buildChannelConnection()}</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default withRouter(ChannelDetails);
